module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iconsCell"
  }, [(_vm.hasNotes) ? _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Has Notes'),
      expression: "'Has Notes'"
    }],
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "ico ico-alert color-6 mr-0 fs-largest"
  })]) : _c('div'), _vm._v(" "), (_vm.hasTransport) ? _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Has transport'),
      expression: "'Has transport'"
    }],
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "ico ico-vehicle mr-0 fs-largest"
  })]) : _c('div'), _vm._v(" "), (_vm.isReservationCanceled) ? _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Reservation Canceled'),
      expression: "'Reservation Canceled'"
    }],
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "ico ico-canceled medium mr-0 fs-largest"
  })]) : (_vm.allPaxCheckedIn) ? _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('All Pax Checked'),
      expression: "'All Pax Checked'"
    }],
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "ico ico-check color-3 mr-0 fs-largest"
  })]) : (_vm.checkInPaxMissing) ? _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Pax missing checkin'),
      expression: "'Pax missing checkin'"
    }],
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "ico ico-check color-4 mr-0 fs-largest"
  })]) : _c('div')])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7568b944", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7568b944"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/reservationLists/columns/icons.vue
// module id = 2710
// module chunks = 0